import {formsStore as legacyStore} from '../../../_legacy/Form/stores/FormsStore';
import {isColumnMandatory} from '../../../_shared/GWTBridge/invoke/formTable';
import {formsStore} from '../../../stores/Form';
import {FormViewEnum} from '../../../stores/Form/Form';
import {ReloadMode} from '../consts';
import {DesignPanels} from '../enums';

export const getCurrentForm = () => {
    return legacyStore.currentSession ? legacyStore.currentForm : formsStore.getActiveForm();
};

export const getMainCurrentForm = () => {
    return legacyStore.currentSession
        ? legacyStore.getFormByLevel('1', legacyStore.sessions.get(legacyStore.currentSession))
        : formsStore.currentScreen.form;
};

export const isFieldMandatory = (ename: string) => {
    if (legacyStore.currentSession) {
        return isColumnMandatory(ename);
    } else {
        return formsStore.getActiveForm().getColumnByName(ename).Mandatory;
    }
};

export const getReloadModeByPanelType = (panelType: DesignPanels, view: FormViewEnum) => {
    if (panelType === DesignPanels.FIELDS) {
        if (view === FormViewEnum.form) {
            return ReloadMode.ROW;
        } else {
            return ReloadMode.TABLE;
        }
    } else {
        return ReloadMode.ACTIONS;
    }
};
